<template>
  <svg class="icon">
    <use :xlink:href="`#${iconName}`"></use>
  </svg>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'IconFont',
  props: {
    iconName: String,
  },
});
</script>

<style lang="less">
.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
</style>
